import * as React from "react";
import { Distance } from "../../domain/common";
import { pipe } from "fp-ts/function";
import { useLangCtx } from "../../utils/i18n/lang";

interface Props {
    distance: Distance;
}

export const LocalDistance = (p: Props) => {
    const [ctx] = useLangCtx();

    return pipe(p.distance, ctx.distanceFormat, (formatted) => (
        <>{formatted}</>
    ));
};
